import React from 'react';
import ReactDOM from 'react-dom/client';
import './bootstrap.scss';
import './generated/bootstrap-icons.css';
import './App.css';
import App from './App';

import { loadVisitorCountry } from './shared/signup/usd';

// The visitor's country decides the order of the store designs (international ones first outside India), so it is
// looked up first; this waits at most a moment, and only on the first visit of the day
const root = ReactDOM.createRoot(document.getElementById('root'));
loadVisitorCountry().then(() => root.render(<React.StrictMode><App /></React.StrictMode>));